import {isNotStringOrEmptyString} from "@utils/string";
import {isInLabelValueArrayAsString} from "@utils/validators";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import {
   PREMISE_FLOORING_TYPE_OPTIONS, PREMISE_OCCUPATION_TIME_OPTIONS,
   PREMISE_ROOFING_TYPE_OPTIONS, PREMISE_WALL_TYPE_OPTIONS
} from "@constants/form-optins/business-insurance-options";

export const ValidateStep4Data = (data) => {
   
   const msgList = [/*{
      name: 'halt',
      message: 'Halt'
   }*/];
   
   if(isNotStringOrEmptyString(data.businessPremiseLocation)) {
      
      msgList.push({
         name: 'businessPremiseLocation',
         message: 'Please specify the business premise location'
      });
      
   }
   
   if(isNotStringOrEmptyString(data.businessOpeningHours)) {
      msgList.push({
         name: 'businessOpeningHours',
         message: 'Please specify the business opening hours'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.hasCcTvCameraInsidePremise,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hasCcTvCameraInsidePremise',
         message: 'Please specify if the business has a CCTV camera inside the premise'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.isThePremiseEntitledAsListedBuilding,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'isThePremiseEntitledAsListedBuilding',
         message: 'Please specify if the premise is entitled as a listed building'
      });
   }
   
   if(isNotStringOrEmptyString(data.premiseRoofType) || !isInLabelValueArrayAsString(data.premiseRoofType,PREMISE_ROOFING_TYPE_OPTIONS)) {
      msgList.push({
         name: 'premiseRoofType',
         message: 'Please specify the type of roofing on the premise'
      });
   }
   
   if(isNotStringOrEmptyString(data.premiseFlooringType) || !isInLabelValueArrayAsString(data.premiseFlooringType,PREMISE_FLOORING_TYPE_OPTIONS)) {
      msgList.push({
         name: 'premiseFlooringType',
         message: 'Please specify the type of flooring on the premise'
      });
   }
   
   if(isNotStringOrEmptyString(data.premiseWallType) || !isInLabelValueArrayAsString(data.premiseWallType,PREMISE_WALL_TYPE_OPTIONS)) {
      msgList.push({
         name: 'premiseWallType',
         message: 'Please specify the type of wall on the premise'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.doesAnyoneLiveUpStairs,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'doesAnyoneLiveUpStairs',
         message: 'Please specify if anyone lives upstairs'
      });
   }
   
   if('Yes' === data.doesAnyoneLiveUpStairs) {
      
      if(isNotStringOrEmptyString(data.whoLivesUpStairs)) {
         msgList.push({
            name: 'whoLivesUpStairs',
            message: 'Please specify who lives upstairs'
         });
      }
      
   }
   
   if(!isInLabelValueArrayAsString(data.isBackDoorSecured,YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name : 'isBackDoorSecured',
         message : 'Please specify if the back door is secured'
      });
      
   }
   
   if(!isInLabelValueArrayAsString(data.premiseOccupationTime,PREMISE_OCCUPATION_TIME_OPTIONS)) {
      msgList.push({
         name: 'premiseOccupationTime',
         message: 'Please specify when the premise is occupied'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.hasRollerShuttersOnPremise,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hasRollerShuttersOnPremise',
         message: 'Please specify if the premise has a roller shutter'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.hasGrillsOnPremise,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hasGrillsOnPremise',
         message: 'Please specify if the premise has a grill fitted'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.hasAlarmsOnPremise,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hasAlarmsOnPremise',
         message: 'Please specify if the premise has an alarm fitted'
      });
   }
   
   if('Yes' === data.hasAlarmsOnPremise) {
   
      if(isNotStringOrEmptyString(data.premiseAlarmDetails)) {
         msgList.push({
            name: 'premiseAlarmDetails',
            message: 'Please specify the details of the alarm fitted on the premise'
         });
      }
      
      if(!isInLabelValueArrayAsString(data.doesAlarmNotifyPolice,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: 'doesAlarmNotifyPolice',
            message: 'Please specify if the alarm notifies the police aside from you'
         });
      }
      
      if(!isInLabelValueArrayAsString(data.isPremiseAlarmCheckedRegularly,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: 'isPremiseAlarmCheckedRegularly',
            message: 'Please specify if the alarm is checked regularly'
         });
      }
   
      
      
   }
   
   if(!isInLabelValueArrayAsString(data.hasCommercialKitchenOnPremise,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hasCommercialKitchenOnPremise',
         message: 'Please specify if the premise has a commercial kitchen'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.isRunningACaffeOrTakeAwayRestaurant,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'isRunningACaffeOrTakeAwayRestaurant',
         message: 'Please specify if the premise is running a café, take away or a restaurant'
      });
   }
   
   return msgList;
   
}